import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serviceurl } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class CityWebDataService {

  serviceCityUrl: string = serviceurl + 'api/content-city'
  serviceUrl: string = serviceurl;
  constructor(private httpClient: HttpClient) {
  }

  insertCityHistoryData(charId, historyData) {
    return this.httpClient.post(this.serviceCityUrl + `/create-citylocationhistory/`, historyData)
  }

  citylocationhistory(historyData) {
    return this.httpClient.post(serviceurl + `/api/party/city-location-history/`, historyData)
  }

  getCityHistoryData(charId, mapCode, cityCode) {
    return this.httpClient.get(this.serviceCityUrl + `/getlist-character_id/${charId}/${mapCode}/${cityCode}/`)

    // api/content-city/getlist-character_id/<int:character_id>/<str:mapcode>/<str:citycode>/
  }

  getCitylocationhistoryGame(charId, mapCode, cityCode) {
    return this.httpClient.get(serviceurl + `/api/party/get-location-history/${charId}/${mapCode}/${cityCode}/`)

    // api/content-city/getlist-character_id/<int:character_id>/<str:mapcode>/<str:citycode>/
  }

  cityInsertSharedLocation(data) {
    return this.httpClient.post(this.serviceCityUrl + '/create-citysharedlocation/', data)
  }

  cityGetSharedLocation(charId, mapCode, cityCode) {
    return this.httpClient.get(this.serviceCityUrl + `/getlist-citysharedlocation-characterid/${charId}/${mapCode}/${cityCode}/`)
  }

  toggleBookMark(obj) {
    const dataObj = {
      id: obj.id
    }
    return this.httpClient.post(this.serviceCityUrl + `/toggle-Bookmark/`, dataObj)
  }

  getCityFavroiteData(charId, mapCode, cityCode) {
    return this.httpClient.get(this.serviceCityUrl + `/getlist-favourite/${charId}/${mapCode}/${cityCode}/`)
  }

  updateCityMovmentHistory(historyRecord) {
    return this.httpClient.put(this.serviceCityUrl + `/location-history/${historyRecord.id}/`, historyRecord)
  }


  getContentCityByUserId(user_id) {
    return this.httpClient.get(this.serviceCityUrl + `/getlist-userid/${user_id}/`)
  }

  getContentCityById(id) {
    return this.httpClient.get(this.serviceCityUrl + `/getlist-contentcityid/${id}/`)
  }

  getContentCityByMapCodeCityId(userId, map_id, city_id) {
    return this.httpClient.get(this.serviceUrl + `api/ui/content/all/${userId}/`, {
      params: { map_id, city_id },
      headers: new HttpHeaders({ 'loader': 'Loading this city\'s content...' })
    })
  }

  createCityContentByUser(contentRecord) {
    return this.httpClient.post(this.serviceCityUrl + '/create-contentcity/', contentRecord)
  }

  updateCityContentByUser(id, contentRecord) {
    return this.httpClient.put(this.serviceCityUrl + `/updatedata-contentcityid/${id}/`, contentRecord)
  }

  deleteContentCreaterImage(id) {
    return this.httpClient.delete(this.serviceCityUrl + `/delete-particularcontencityfile/${id}/`)
  }

  deleteCityContentById(id) {
    return this.httpClient.delete(this.serviceCityUrl + `/delete-contentcityid/${id}/`)

  }

  getMapCityData(map_id: number | string, city_code: string) {
    const payload = {
      map_code: map_id,
      city_id: city_code
    };
    return this.httpClient.post(this.serviceUrl + `api/cell-resource-details/`, payload, {
      headers: new HttpHeaders({ 'loader': 'Reading this spot of the map...' })
    });
  }

  updateCityPartyJournal(historyData) {
    return this.httpClient.put(serviceurl + `api/party/update-city-location-history/${historyData.id}/`, historyData)
  }

  downloadCityContentFiles(contentId: number | string) {
    return this.httpClient.get(this.serviceCityUrl + `/${contentId}/download/`, { responseType: 'blob' });
  }

  charCurrentCity(user_id: string | number, char_id: any) {
    return this.httpClient.get(this.serviceUrl + `character/city/?user_id=${user_id}&character_id=${char_id}`)
  }

  gameCurrentCity(game_id: string | number) {
    return this.httpClient.get(this.serviceUrl + `game/game-city/?game_id=${game_id}`)
  }

  checkCurrentCityChildrenForCharacter(char_id: string | number, map_code: string | number) {
    return this.httpClient.get(this.serviceUrl + `api/location-history/character/${char_id}/${map_code}/last-status/`)
  }
  checkCurrentCityChildrenForGame(game_id: string | number, map_code: string | number) {
    return this.httpClient.get(this.serviceUrl + `api/location-history/party/${game_id}/${map_code}/last-status/`)
  }
}